<template>
  <div class="license_cla">
    <el-row :gutter="20">
      <el-col :span="12"
              class="item">
        <el-card shadow="always"
                 style="height:100%">
          <p>{{$t('license.curLicense')}}</p>
          <ZkKvLine :label="$t('license.licenseStatus')"
                    :class="runTypeClass">{{curInfo.runTypeName}}</ZkKvLine>
          <ZkKvLine :label="$t('license.licentseValidity')">{{curInfo.endDate}}</ZkKvLine>
          <ZkKvLine :label="$t('license.deviceMax')">{{curInfo.maxDeviceNum}}</ZkKvLine>
          <ZkKvLine :label="$t('license.curDevice')">{{curInfo.currDevNum}}</ZkKvLine>
        </el-card>
      </el-col>
      <el-col :span="12"
              class="item">
        <el-card shadow="always"
                 style="height:100%">
          <p>{{$t('license.newsLicense')}}</p>
          <ZkKvLine :label="$t('license.aduitStatus')"
                    :class="statusClass">{{newestInfo.statusName}}</ZkKvLine>
          <ZkKvLine :label="$t('license.applyDevice')">{{newestInfo.applyDevMaxNum}}</ZkKvLine>
          <ZkKvLine :label="$t('license.applyDate')">{{newestInfo.applyEndDay |applyEndDayFormat}}<span v-if="newestInfo.applyEndDay">{{$t('license.year')}}</span></ZkKvLine>
          <ZkKvLine :label="$t('license.remark')">{{newestInfo.description}}</ZkKvLine>
          <ZkKvLine :label="$t('license.approvalTime')">{{newestInfo.auditTime}}</ZkKvLine>

        </el-card>
      </el-col>
      <el-col :span="24"
              class="item">
        <el-card shadow="always"
                 style="height:100%">
          <p>{{$t('license.custormInfo')}}</p>
          <ZkKvLine :label="$t('license.custormNo')">{{cusInfo.clientId}}</ZkKvLine>
          <ZkKvLine :label="$t('license.custormContact')">{{cusInfo.name}}</ZkKvLine>
          <ZkKvLine :label="$t('license.custormPhone')">{{cusInfo.phone |phoneFormat}}</ZkKvLine>
          <ZkKvLine :label="$t('license.custormEmail')">{{cusInfo.email |emailFormat}}</ZkKvLine>
          <ZkKvLine :label="$t('license.custormCompany')">{{cusInfo.company}}</ZkKvLine>
        </el-card>
      </el-col>
      <el-col :span="24"
              class="item">
        <el-card shadow="always"
                 style="height:100%;text-align:center">
          <el-button type="primary"
                     @click.stop="showDailog('online')">{{$t('license.onlineLicense')}}</el-button>
          <el-button type="primary"
                     @click.stop="showDailog('offline')">{{$t('license.offlineLicense')}}</el-button>
          <el-button type="primary"
                     @click.stop="importLicense">{{$t('license.importLicense')}}</el-button>
        </el-card>
      </el-col>
    </el-row>
    <LisenceDailog :dialogVisible="dialogVisible"
                   :cusInfo="cusInfo"
                   :type="type"
                   @close="close"
                   @sumbit="sumbit"
                   ref="lisenceDailog"></LisenceDailog>

    <el-dialog :title="$t('license.titles')"
               :visible.sync="licenseDailog"
               width="45%"
               @close="closeLicenseDailog">
      <el-row>
        <el-col :span="24"
                align="center">
          <el-upload class="upload-demo"
                     drag
                     action="/license/uploadlic"
                     :before-upload="beforeAvatarUpload"
                     :on-success="handUploadSuc"
                     :on-error="handUploadErr">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">{{$t('license.uploadTips1')}}<em>{{$t('license.uploadTips2')}}</em></div>
          </el-upload>
        </el-col>
      </el-row>

    </el-dialog>
  </div>
</template>

<script>
import * as Licese from '@/services/license'
import LisenceDailog from './licenseDailog.vue'
export default {
  data () {
    return {
      runType: 2,
      status: -1,
      dialogVisible: false,
      cusInfo: {
        clientId: '',
        name: '',
        phone: '',
        email: '',
        company: ''
      },
      curInfo: {
        runTypeName: '',
        endDate: '',
        maxDeviceNum: '',
        currDevNum: ''
      },
      newestInfo: {
        statusName: '',
        applyDevMaxNum: '',
        applyEndDay: '',
        description: '',
        auditTime: ''
      },
      type: '',
      licenseDailog: false
    }
  },
  computed: {
    runTypeClass () {
      let result = ''
      switch (this.runType) {
        case '-2':
          result = 'label-status-danger'
          break
        case '-1':
          result = 'label-status-warning'
          break
        case '0':
          result = 'label-status-info'
          break
        case '1':
          result = 'label-status-primary'
          break
        default:
          result = ''
          break
      }
      return result
    },
    statusClass () {
      let result = ''
      switch (this.status) {
        case '2':
          result = 'label-status-danger'
          break
        case '1':
          result = 'label-status-primary'
          break
        case '0':
          result = 'label-status-warning'
          break
        default:
          result = ''
          break
      }
      return result
    }
  },
  mounted () {
    this.loadLicenseInfo()
    this.loadNewestApplyOnlineInfo()
  },
  filters: {
    applyEndDayFormat (val) {
      if (!val) {
        return ''
      }
      let temp = val.split('/')

      return `${temp[0]}`
    }
  },
  components: {
    LisenceDailog
  },
  methods: {
    beforeAvatarUpload () {

    },
    handUploadSuc (res) {
      if (res.code === '00000000') {
        this.$message.success(this.$t('com_log.success'))
      }
    },
    handUploadErr (err, file, fileList) {
      console.log('err', err)
      const result = JSON.parse(err.message)
      this.$message.error(result)
    },
    closeLicenseDailog () {
      this.lisenceDailog = false
    },
    importLicense () {
      this.licenseDailog = true
    },
    sumbit (val) {
      Licese.saveCusInfo(val).then(data => {
        if (data.code === '00000000') {
          if (this.type === 'online') {
            this.$refs.lisenceDailog.jumpOnline()
          } else if (this.type === 'offline') {
            this.$refs.lisenceDailog.jumpOffline()
          }
        } else {
          this.$message.error(data.message)
        }
      })
      this.close()
    },
    close () {
      this.dialogVisible = false
    },
    showDailog (value) {
      this.dialogVisible = true
      this.type = value
    },
    loadLicenseInfo () {
      Licese.getLicenseInfo().then(data => {
        if (data.code === '00000000') {
          this.cusInfo.clientId = data.payload.results.clientId
          this.cusInfo.name = data.payload.results.name
          this.cusInfo.phone = data.payload.results.phone
          this.cusInfo.email = data.payload.results.email
          this.cusInfo.company = data.payload.results.company

          this.curInfo.runTypeName = data.payload.results.runTypeName
          this.curInfo.endDate = data.payload.results.endDate
          this.curInfo.maxDeviceNum = data.payload.results.maxDeviceNum
          this.curInfo.currDevNum = data.payload.results.currDevNum

          this.runType = data.payload.results.runType
        }
      }).catch(e => { console.log(e) })
    },
    loadNewestApplyOnlineInfo () {
      Licese.getNewestApplyOnlineInfo().then(data => {
        if (data.code === '00000000') {
          this.newestInfo.statusName = data.payload.results.licenseApplyInfo.statusName
          this.newestInfo.applyDevMaxNum = data.payload.results.licenseApplyInfo.applyDevMaxNum
          this.newestInfo.applyEndDay = data.payload.results.licenseApplyInfo.applyEndDay
          this.newestInfo.description = data.payload.results.licenseApplyInfo.description
          this.newestInfo.auditTime = data.payload.results.licenseApplyInfo.auditTime

          this.status = data.payload.results.licenseApplyInfo.status
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/styles/var.less';
.label-status-danger {
  color: @ststusFailed;
}
.label-status-warning {
  color: @statusWarning;
}
.label-status-info {
  color: @statusNormal;
}
.label-status-primary {
  color: @themeColor;
}
.license_cla {
  .item {
    margin: 10px 0;
    height: 300px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/license/license.vue